var CoC = CoC || {};
CoC.lang = CoC.lang || {};

CoC.lang['ru'] = {
  name:'Русский',
  model: { 
  
    //Champion name 
    'champion-blackbolt-name': 'Черный Гром',
    'champion-captainmarvel-name': 'Капитан Марвел',
    'champion-drax-name': 'Дракс',
    'champion-gamora-name': 'Гамора',
    'champion-msmarvel-name': 'Мисс Марвел',
    'champion-ronan-name': 'Ронан',
    'champion-spidermanblack-name': 'Черный Человек-Паук',
    'champion-superiorironman-name': 'Высший Железный Человек',
    'champion-thor-name': 'Тор',
    'champion-thorjanefoster-name': 'Джейн Фостер',
    'champion-venom-name': 'Веном',
    'champion-ironman-name': 'Железный Человек',
    'champion-ironpatriot-name': 'Железный Патриот',
    'champion-hulkbuster-name': 'Халкбастер',
    'champion-kang-name': 'Канг',
    'champion-rocket-name': 'Реактивный Енот',
    'champion-starlord-name': 'Звездный Лорд',
    'champion-vision-name': 'Вижн',
    'champion-thevision-name': 'Вижн Кино',
    'champion-ultron-name': 'Альтрон Прайм',
    'champion-warmachine-name': 'Воитель',
    'champion-colossus-name': 'Колосс',
    'champion-cyclops-name': 'Циклоп',
    'champion-deadpool-name': 'Дедпул',
    'champion-deadpoolxforce-name': 'Дедпул X-Force',
    'champion-magneto-name': 'Магнето',
    'champion-magnetomarvelnow-name': 'Белый Магнето',
    'champion-storm-name': 'Шторм',
    'champion-wolverine-name': 'Росомаха',
    'champion-blackpanther-name': 'Черная Пантера',
    'champion-blackwidow-name': 'Черная Вдова',
    'champion-daredevil-name': 'Сорвиголова',
    'champion-daredevilnetflix-name': 'Сорвиголова Netflix',
    'champion-elektra-name': 'Электра',
    'champion-hawkeye-name': 'Соколиный Глаз',
    'champion-moonknight-name': 'Лунный Рыцарь',
    'champion-punisher-name': 'Каратель',
    'champion-wintersoldier-name': 'Зимний Солдат',
    'champion-abomination-name': 'Мерзость',
    'champion-antman-name': 'Человек Муравей',
    'champion-captainamerica-name': 'Капитан Америка',
    'champion-captainamericawwii-name': 'Капитан Америка WWII',
    'champion-electro-name': 'Электро',
    'champion-hulk-name': 'Халк',
    'champion-joefixit-name': 'Джо Фиксит',
    'champion-rhino-name': 'Носорог',
    'champion-spidergwen-name': 'Спайдер Гвен',
    'champion-spiderman-name': 'Человек-Паук',
    'champion-spidermanmorales-name': 'Человек-Паук Моралес',
    'champion-yellowjacket-name': 'Желтый Шершень',
    'champion-drstrange-name': 'Доктор Стрэндж',
    'champion-ironfist-name': 'Железный Кулак',
    'champion-juggernaut-name': 'Джаггернаут',
    'champion-magik-name': 'Мэджик',
    'champion-scarletwitch-name': 'Алая Ведьма',
    'champion-unstoppablecolossus-name': 'Неудержимый Колосс',
    
    //Champion shortnames
    'champion-blackbolt-shortname': 'Гром',
    'champion-captainmarvel-shortname': 'Кэп Марвел',
    'champion-drax-shortname': 'Дракс',
    'champion-gamora-shortname': 'Гамора',
    'champion-msmarvel-shortname': 'Мисс',
    'champion-ronan-shortname': 'Ронан',
    'champion-spidermanblack-shortname': 'Черный Паук',
    'champion-superiorironman-shortname': 'СЖЧ',
    'champion-thor-shortname': 'Тор',
    'champion-thorjanefoster-shortname': 'Джейн Фостер',
    'champion-venom-shortname': 'Веном',
    'champion-ironman-shortname': 'ЖЧ',
    'champion-ironpatriot-shortname': 'ЖП',
    'champion-hulkbuster-shortname': 'ХБ',
    'champion-kang-shortname': 'Канг',
    'champion-rocket-shortname': 'Енот',
    'champion-starlord-shortname': 'Лорд',
    'champion-vision-shortname': 'Вижн',
    'champion-thevision-shortname': 'Вижн Кино',
    'champion-ultron-shortname': 'Альтрон',
    'champion-warmachine-shortname': 'Воитель',
    'champion-colossus-shortname': 'Колосс',
    'champion-cyclops-shortname': 'Циклоп',
    'champion-deadpool-shortname': 'Дед',
    'champion-deadpoolxforce-shortname': 'Дед седой',
    'champion-magneto-shortname': 'Магнит',
    'champion-magnetomarvelnow-shortname': 'Белый Магнит',
    'champion-storm-shortname': 'Шторм',
    'champion-wolverine-shortname': 'Рося',
    'champion-blackpanther-shortname': 'Пантера',
    'champion-blackwidow-shortname': 'Вдова',
    'champion-daredevil-shortname': 'Сорвиголова',
    'champion-daredevilnetflix-shortname': 'Сорвиголова Netflix',
    'champion-elektra-shortname': 'Электра',
    'champion-hawkeye-shortname': 'Сокол',
    'champion-moonknight-shortname': 'Лунатик',
    'champion-punisher-shortname': 'Кара',
    'champion-wintersoldier-shortname': 'Зимний',
    'champion-abomination-shortname': 'Мерзость',
    'champion-antman-shortname': 'Муравей',
    'champion-captaishortnamerica-shortname': 'Кэп',
    'champion-captaishortnamericawwii-shortname': 'Кэп ВМВ',
    'champion-electro-shortname': 'Электрик',
    'champion-hulk-shortname': 'Халк',
    'champion-joefixit-shortname': 'Фиксит',
    'champion-rhino-shortname': 'Носорог',
    'champion-spidergwen-shortname': 'Гвен',
    'champion-spiderman-shortname': 'Паук',
    'champion-spidermanmorales-shortname': 'Моралес',
    'champion-yellowjacket-shortname': 'Шершень',
    'champion-drstrange-shortname': 'Док',
    'champion-ironfist-shortname': 'Кулак',
    'champion-juggernaut-shortname': 'Джаг',
    'champion-magik-shortname': 'Мэджик',
    'champion-scarletwitch-shortname': 'Ведьма',
    'champion-unstoppablecolossus-shortname': 'Неуд',
    
    //Effect name 
    'effect-attack-name': 'Атака',
    'effect-stun-name': 'Оглушение',
    'effect-critrate-name': 'Вероятность крит. урона',
    'effect-critdamage-name': 'Крит. Урон',
    'effect-powergain-name': 'Увеличение Энергии',
    'effect-powersteal-name': 'Кража Энергии',
    'effect-perfectblock-name': 'Идеальный Блок',
    'effect-block-name': 'Вероятность ид. блока',
    'effect-armor-name': 'Броня',
    'effect-health-name': 'Здоровье',
    'effect-healthsteal-name': 'Кража здоровья',
    
    //Effect description 
    'effect-attack-description': 'Увеличение урона на все атаки.',
    'effect-stun-description': 'Шанс оглушения при спец. атаках.',
    'effect-critrate-description': 'Увеличение вероятности крит. урона.',
    'effect-critdamage-description': 'Увеличение критического урона.',
    'effect-powergain-description': 'Увеличечние энергии (от спец. атак) независимо от атаки.',
    'effect-powersteal-description': 'Кража энергии (от спец. атак) за счет атаки.',
    'effect-perfectblock-description': 'Увеличение шанса идеального блока - 0 урона в блоке.',
    'effect-block-description': 'Увеличение эффективности блокирования - уменьшение урона в блоке.',
    'effect-armor-description': 'Увеличение брони, тем самым уменьшая получаемый урон.',
    'effect-health-description': 'Увеличение здоровья чемпиона.',
    'effect-healthsteal-description': 'Восполнение здоровья при атаке.',
    
    //Type name 
    'type-cosmic-name': 'Космос',
    'type-tech-name': 'Технологии',
    'type-mutant-name': 'Мутации',
    'type-skill-name': 'Способности',
    'type-science-name': 'Наука',
    'type-mystic-name': 'Мистика',
    
    //Crystal name 
    'crystal-versus-name': 'Кристалл за битвы',
    'crystal-arena-name': 'Кристалл Арены',
    'crystal-alliance-name': 'Кристалл союза',
    'crystal-daily-name': 'Ежедневный кристалл',
    'crystal-2star-name': 'Кристалл героя с 2-мя звездами',
    'crystal-premium-name': 'Усиленный кристалл героя',
    'crystal-3star-name': 'Кристалл героя с 3-мя звездами',
    'crystal-4star-name': 'Кристалл героя с 4-мя звездами',
    
    //Crystal description (keep $CURRENCY$ tokens for image replacement) 
    'crystal-versus-description': 'Даётся за победу на арене 1vs1.',
    'crystal-arena-description': 'Покупается за 2000 $BATTLECHIPS$.',
    'crystal-alliance-description': 'Покупается за 1000 $LOYALTY$.',
    'crystal-daily-description': 'Появляется каждые 24 часа.',
    'crystal-premium-description': 'Покупается за 100 $UNITS$.',
    'crystal-3star-description': 'Покупается за 400 $UNITS$, редкая акция.',
    'crystal-4star-description': 'Покупается за 2500 $UNITS$, очень редкая акция.',

    //Algorithm name
    'algorithm-greedy-name': 'Greedy',
    'algorithm-shuffle-name': 'Смешанный',

    //Algorithm description
    'algorithm-greedy-description': 'МЕДЛЕННЫЙ. Выбирает команды, используя математический просчет на основе введенных апраметров.',
    'algorithm-shuffle-description': 'БЫСТРЫЙ. Выбирает лучшую возможную комбинацию команды.',
  },
  string: { 
  
      //Listing words 
    'of': 'из',
    'with': 'с',
    'found': 'Найден',
    'extras': 'Экстра',
    
    //Common words/sections 
    'team': 'Команда',
    'teams': 'Команды',
    'guide': 'Руководство',
    'guides': 'Руководства',
    'champion': 'Чемпион',
    'champions': 'Чемпионы',
    'synergy': 'Синергия',
    'synergies': 'Синергии',
    'crystal': 'Кристалл',
    'crystals': 'Кристаллы',
    'roster': 'Список',
    
    //Roster Panel 
    'manage': 'Управление',
    'add-champion': 'Добавить чемпиона',
    'import-csv': 'Импорт .csv',
    'export-csv': 'Экспорт .csv',
    'delete-all': 'Удалить всех',
    'sort': 'Сортировать',
    'filter': 'Фильтр',
    
    //Roster Config 
    'stars': 'Категория',
    'type': 'Класс',
    'name': 'Имя',
    
    'rank': 'Ранг',
    'level': 'Уровень',
    'awakened': 'Дубль',
    'quest': 'Задание',
    'view-guide': 'Посмотреть руководство',
    
    'delete': 'Удалить',
    'cancel': 'Отмена',
    
    'ask-delete': 'Вы уверены, что хотите удалить?',
    'ask-delete-all': 'Вы уверены, что хотите удалить всех чемпионов?',
    'cannot-undo': 'Это действие не может быть отменено.',
    
    //Team Panel 
    'advanced-settings': 'Дополнительные настройки',
    'team-size': 'Размер команды',
    'algorithm': 'Алгоритм',
    'quest-group': 'Группа задания',
    'build': 'Построить',
    
    //Add Champion Page
    'add-all': 'Добавить всех',
   
    //Advanced Settings Page
    'reset-defaults': 'Восстановить стандартные настройки',
    'champion-weights':'Уровни чемпионов',
    'synergy-weights': 'Уровни синергии',
    'duplicate-weights': 'Уровни дублей',
    'choose-preset': 'Выберите предустановку...',
    'use-levels': 'Просчитать используя звезды / ранги / уровни',
    
    //Tuples 
    'double': 'Двойной',
    'triple': 'Тройной',
    'quadruple': 'Четверной',
    'quintuple': 'Пятерной',
    
    //Guide Page 
    'choose-guide': 'Выберите руководство',
    
    //Options
    'options': 'Опции',
    'share-to': 'Поделиться',
    'facebook': 'Facebook',
    'twitter': 'Twitter',
    'google': 'Google',
    'language': 'Язык',
    'tools': 'Опции',
    'synergy-map': 'Карта синергии',
    'roster-manager': 'Манеджер списка',
    
    //Onboarding Messages 
    'onboarding-synergies': 'Используейте меню настройки списка, чтобы добавить еще чемпионов.',
    'onboarding-roster': 'Откройте настройки, чтобы добавить нового чемпиона',
    'onboarding-teams': 'Используйте меню строителя, чтобы создать свою команду!',
    
    //Guide 
    'coming-soon': 'Скоро обновление...',
    'gameplay': 'Геймплей',
    'special': 'Специальные атаки',
    'signature': 'Коронная способность',
    'heavy-attack': 'Тяжелая атака',
    'abilities': 'Способности',
    
    'grade': 'Оценка',
    'strategy': 'Стратегия',
    
    'damage-type': 'Тип урона',
    'range': 'Дальний',
    'note': 'Заметка',
    
    'synergies-external': 'Синергия от других чемпионов',
    
    'none': 'Отсутствует',
  }
};
// http://collabedit.com/uuf57
